export type FallbackImageProps = {
  src: string;
  alt: string;
  fallbackSrc: string;
  maxWidth: number;
}

function ImageWithFallback(props: FallbackImageProps) {
  const {src, alt, fallbackSrc, maxWidth} = props
  return (
    <img
      src={src}
      alt={alt}
      onError={(e) => (e.currentTarget.src = fallbackSrc)}
      style={{maxWidth: maxWidth > 224 ? '224px': '100%'}}
    />
  );
}

export default ImageWithFallback;